import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _p = null;
export const loadTeamSenders = (force = false) => {
  if (!_p || force) _p = axios.get(`${API}/team-senders`).then((r) => r.data).catch(() => ({ items: [], me: null, brand: null }));
  return _p;
};

// "Send from" picker: team members (with their signature) or the Care Tech Compare team brand.
export default function SenderSelect({ value, onChange, disabled, testid = 'sender-select', dark = false, allowBrand = true }) {
  const [d, setD] = useState({ items: [], me: null, brand: null });
  useEffect(() => { loadTeamSenders().then(setD); }, []);
  const cur = d.items.find((s) => s.id === value);
  const cls = dark ? 'bg-slate-900 border-slate-700 text-[#ffffff]' : 'bg-white border-slate-200 text-slate-900';
  return (
    <div>
      <select value={value || ''} disabled={disabled} onChange={(e) => onChange(e.target.value || null, d.items.find((s) => s.id === e.target.value) || null)}
        className={`mt-1 w-full rounded-md border px-3 py-2 text-sm ${cls}`} data-testid={testid}>
        {allowBrand && <option value="">{d.brand?.name || 'Care Tech Compare (team)'}</option>}
        {d.items.map((s) => <option key={s.id} value={s.id}>{`${s.name}${s.id === d.me ? ' (you)' : ''} · ${s.sender_email}`}</option>)}
      </select>
      <p className={`text-[10px] mt-1 ${dark ? 'text-slate-500' : 'text-slate-400'}`} data-testid={`${testid}-hint`}>
        {cur ? `Sends as ${cur.name} <${cur.sender_email}>, replies go to them, and their signature${cur.job_title ? ` (${cur.job_title})` : ''} is added automatically.${cur.verified_domain ? '' : ' Note: this address is not on the verified sending domain yet.'} Edit signatures in Settings > My signature.`
          : 'Sends as the Care Tech Compare team with the brand signature.'}
      </p>
    </div>
  );
}

export const useMe = () => {
  const [me, setMe] = useState(null);
  useEffect(() => { loadTeamSenders().then((d) => setMe(d.me)); }, []);
  return me;
};
